var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "main-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            { staticClass: "search-section" },
            [
              _c("div", { staticClass: "search-header" }, [
                _c("div", { staticClass: "search-title" }, [
                  _c("i", { staticClass: "el-icon-search" }),
                  _vm._v("\n          筛选搜索\n      "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "search-actions" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-search",
                          size: "small",
                        },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("\n            搜索\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh", size: "small" },
                        on: { click: _vm.resetFilter },
                      },
                      [_vm._v("\n            重置\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "success",
                          icon: "el-icon-plus",
                          size: "small",
                        },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("\n            新增商户\n          ")]
                    ),
                    _vm._v(" "),
                    _c("async-export-button", {
                      attrs: {
                        type: "merchant_supplier",
                        params: _vm.supplierExportParams,
                        "show-progress-dialog": true,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "el-dropdown",
                      {
                        staticStyle: { "margin-left": "8px" },
                        attrs: { trigger: "click" },
                        on: { command: _vm.handleSyncCommand },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              icon: "el-icon-refresh",
                              size: "small",
                              loading: _vm.syncLoading,
                            },
                          },
                          [
                            _vm._v("\n              数据同步 "),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right",
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-dropdown-menu",
                          {
                            staticClass: "sync-dropdown-menu",
                            attrs: { slot: "dropdown" },
                            slot: "dropdown",
                          },
                          [
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "fullSync" } },
                              [
                                _c("i", { staticClass: "el-icon-refresh" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("全量同步")]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "syncConfig" } },
                              [
                                _c("i", { staticClass: "el-icon-setting" }),
                                _vm._v(" "),
                                _c("span", [_vm._v("同步参数配置")]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "search-form",
                  attrs: {
                    model: _vm.filterForm,
                    size: "small",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-row",
                    { staticClass: "filter-row", attrs: { gutter: 20 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "filter-item",
                              attrs: { label: "搜索类型" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-control",
                                  attrs: { placeholder: "请选择" },
                                  on: { change: _vm.handleSearchTypeChange },
                                  model: {
                                    value: _vm.filterForm.searchType,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm,
                                        "searchType",
                                        $$v
                                      )
                                    },
                                    expression: "filterForm.searchType",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: {
                                      label: "商户名称",
                                      value: "merchantName",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "账号",
                                      value: "loginAccount",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: {
                                      label: "微信群名称",
                                      value: "wechatGroupName",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "filter-item",
                              attrs: { label: "搜索内容" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "filter-control",
                                attrs: {
                                  placeholder: _vm.getSearchPlaceholder(),
                                  clearable: "",
                                },
                                nativeOn: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleSearch($event)
                                  },
                                },
                                model: {
                                  value: _vm.filterForm.searchValue,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "searchValue", $$v)
                                  },
                                  expression: "filterForm.searchValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "filter-item",
                              attrs: { label: "归属公司" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-control",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                    filterable: "",
                                    "filter-method": _vm.handleCompanySearch,
                                  },
                                  model: {
                                    value: _vm.filterForm.company,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterForm, "company", $$v)
                                    },
                                    expression: "filterForm.company",
                                  },
                                },
                                _vm._l(_vm.companyOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "filter-item",
                              attrs: { label: "合作状态" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-control",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.filterForm.cooperationStatus,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm,
                                        "cooperationStatus",
                                        $$v
                                      )
                                    },
                                    expression: "filterForm.cooperationStatus",
                                  },
                                },
                                _vm._l(
                                  _vm.cooperationStatusOptions,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 3 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "filter-item",
                              attrs: { label: "维护人" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-control",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                    filterable: "",
                                    "filter-method": _vm.handleUserSearch,
                                  },
                                  model: {
                                    value: _vm.filterForm.maintainer,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm,
                                        "maintainer",
                                        $$v
                                      )
                                    },
                                    expression: "filterForm.maintainer",
                                  },
                                },
                                _vm._l(_vm.maintainerOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label:
                                        "" +
                                        item.realName +
                                        (item.flag == 1
                                          ? "（当前登陆人）"
                                          : ""),
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { attrs: { span: 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "filter-item",
                              attrs: { label: "数据来源" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "filter-control",
                                  attrs: {
                                    placeholder: "请选择",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.filterForm.dataSource,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.filterForm,
                                        "dataSource",
                                        $$v
                                      )
                                    },
                                    expression: "filterForm.dataSource",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "本地", value: "本地" },
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    attrs: { label: "接口", value: "接口" },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-section" },
            [
              _c("div", { staticClass: "table-header" }, [
                _c("div", { staticClass: "table-title" }, [
                  _c("i", { staticClass: "el-icon-s-grid" }),
                  _vm._v("\n          商户列表\n        "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "table-info" }, [
                  _c("span", { staticClass: "info-text" }, [
                    _vm._v("共 " + _vm._s(_vm.pagination.total) + " 条记录"),
                  ]),
                  _vm._v(" "),
                  _vm.selectedRows.length > 0
                    ? _c("span", { staticClass: "selected-info" }, [
                        _vm._v(
                          "\n            已选择 " +
                            _vm._s(_vm.selectedRows.length) +
                            " 项\n          "
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticClass: "merchant-table",
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    stripe: "",
                    "header-cell-style": {
                      background: "#f8fafc",
                      color: "#2d3748",
                      fontWeight: "600",
                    },
                  },
                  on: { "selection-change": _vm.handleSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55", align: "center" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      width: "60",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "merchantId",
                      label: "客户ID",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "merchantName",
                      label: "商户名称",
                      "min-width": "160",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "merchant-name-wrapper" },
                              [
                                _c("i", {
                                  staticClass: "el-icon-office-building",
                                  staticStyle: {
                                    color: "#667eea",
                                    "margin-right": "6px",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "merchant-name" }, [
                                  _vm._v(_vm._s(scope.row.merchantName)),
                                ]),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "company", label: "归属公司", width: "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  scope.row.companyName ||
                                    scope.row.company ||
                                    "-"
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "cooperationStatus",
                      label: "合作状态",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "status-wrapper" },
                              [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.getStatusType(
                                        scope.row.cooperationStatus
                                      ),
                                      effect: "light",
                                      size: "small",
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: _vm.getStatusIcon(
                                        scope.row.cooperationStatus
                                      ),
                                    }),
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getCooperationStatusName(
                                            scope.row.cooperationStatus
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "isAdjust",
                      label: "调价方式",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.isAdjust === 1
                                      ? "success"
                                      : "info",
                                  size: "mini",
                                  effect: "plain",
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getAdjustTypeName(scope.row.isAdjust)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "adjustType",
                      label: "调价范围",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.isAdjust === 1
                              ? _c(
                                  "span",
                                  { staticClass: "adjust-range-text" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.getAdjustRangeName(
                                            scope.row.adjustType
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "adjustRate",
                      label: "调价比例",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.isAdjust === 1 && scope.row.adjustRate
                              ? _c(
                                  "span",
                                  { staticClass: "adjust-rate-text" },
                                  [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.formatAdjustRate(
                                            scope.row.adjustRate
                                          )
                                        ) +
                                        "\n          "
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "leader",
                      label: "负责人",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.leader
                              ? _c("div", { staticClass: "leader-wrapper" }, [
                                  _c("i", {
                                    staticClass: "el-icon-user",
                                    staticStyle: {
                                      color: "#409eff",
                                      "margin-right": "4px",
                                    },
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(scope.row.leader) +
                                      "\n          "
                                  ),
                                ])
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "maintainer",
                      label: "维护人",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.maintainer
                              ? _c(
                                  "div",
                                  { staticClass: "maintainer-wrapper" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-user-solid",
                                      staticStyle: {
                                        color: "#4299e1",
                                        "margin-right": "4px",
                                      },
                                    }),
                                    _vm._v(
                                      "\n             " +
                                        _vm._s(
                                          scope.row.maintainerName ||
                                            scope.row.maintainer
                                        ) +
                                        "\n           "
                                    ),
                                  ]
                                )
                              : _c("span", { staticClass: "empty-text" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "wechatGroupName",
                      label: "微信群名称",
                      width: "140",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.wechatGroupName
                              ? _c("div", { staticClass: "contact-wrapper" }, [
                                  _c("i", {
                                    staticClass: "el-icon-chat-dot-square",
                                    staticStyle: {
                                      color: "#48bb78",
                                      "margin-right": "4px",
                                    },
                                  }),
                                  _vm._v(
                                    "\n             " +
                                      _vm._s(scope.row.wechatGroupName) +
                                      "\n           "
                                  ),
                                ])
                              : _c("span", { staticClass: "empty-text" }, [
                                  _vm._v("-"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dataSource",
                      label: "数据来源",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    scope.row.dataSource === "接口"
                                      ? "success"
                                      : "info",
                                  size: "mini",
                                  effect: "plain",
                                },
                              },
                              [
                                _c("i", {
                                  class:
                                    scope.row.dataSource === "接口"
                                      ? "el-icon-link"
                                      : "el-icon-document",
                                  staticStyle: { "margin-right": "2px" },
                                }),
                                _vm._v(
                                  "\n             " +
                                    _vm._s(scope.row.dataSource) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      width: "150",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "lastSyncTime",
                      label: "最后同步",
                      width: "150",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.lastSyncTime
                              ? _c("div", { staticClass: "sync-time" }, [
                                  _c("i", {
                                    staticClass: "el-icon-refresh",
                                    staticStyle: {
                                      color: "#67c23a",
                                      "margin-right": "4px",
                                    },
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.formatDateTime(
                                          scope.row.lastSyncTime
                                        )
                                      ) +
                                      "\n          "
                                  ),
                                ])
                              : _c("span", { staticClass: "text-muted" }, [
                                  _vm._v("未同步"),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "creator",
                      label: "创建人",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "180",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "action-buttons" },
                              [
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "编辑商户",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "primary",
                                        icon: "el-icon-edit",
                                        size: "mini",
                                        circle: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(scope.row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tooltip",
                                  {
                                    attrs: {
                                      content: "查看详情",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("el-button", {
                                      attrs: {
                                        type: "info",
                                        icon: "el-icon-view",
                                        size: "mini",
                                        circle: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleView(scope.row)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                scope.row.canDelete
                                  ? _c(
                                      "el-tooltip",
                                      {
                                        attrs: {
                                          content: "删除商户",
                                          placement: "top",
                                        },
                                      },
                                      [
                                        _c("el-button", {
                                          attrs: {
                                            type: "danger",
                                            icon: "el-icon-delete",
                                            size: "mini",
                                            circle: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.handleDelete(scope.row)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("div", { staticClass: "pagination-info" }, [
                    _c("span", { staticClass: "info-text" }, [
                      _vm._v(
                        "\n            显示第 " +
                          _vm._s(
                            (_vm.pagination.page - 1) * _vm.pagination.size + 1
                          ) +
                          " -\n            " +
                          _vm._s(
                            Math.min(
                              _vm.pagination.page * _vm.pagination.size,
                              _vm.pagination.total
                            )
                          ) +
                          " 条，\n            共 " +
                          _vm._s(_vm.pagination.total) +
                          " 条记录\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.pagination.page,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.pagination.size,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.pagination.total,
                      background: "",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.dialogTitle,
                visible: _vm.dialogVisible,
                width: "800px",
                "close-on-click-modal": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
                close: _vm.handleCloseDialog,
              },
            },
            [
              _vm.dialogVisible
                ? _c("merchant-form", {
                    attrs: {
                      "merchant-id": _vm.isEdit ? _vm.currentRow.id : null,
                      "is-edit": _vm.isEdit,
                      dataSource: _vm.dataSource,
                    },
                    on: { save: _vm.handleSave, cancel: _vm.handleCloseDialog },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("sync-config-dialog", {
            attrs: {
              visible: _vm.syncConfigVisible,
              "delivery-templates": _vm.deliveryTemplates,
              "region-options": _vm.regionOptions,
              "initial-data": _vm.defaultConfig,
            },
            on: {
              "update:visible": function ($event) {
                _vm.syncConfigVisible = $event
              },
              "sync-completed": _vm.handleSyncCompleted,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }